import logo from '../../images/reddit-logo-white.png'

export default function Home() {
    return (

        <div className='home'>
            <h1 id='home-text'>Search Reddit by keyword or drop-down menu</h1>
            <img id='white-logo' src={logo} alt='reddit logo'></img>    
        </div>
    )
} 